export default {
    title: 'Formular erstellen',
    createForm: 'Formular erstellen',
    createAndEditForm: 'Erstellen und weiter bearbeiten',
    createFormSuccess: 'Das Formular wurde erfolgreich erstellt.',
    createFormError: 'Das Formular konnte nicht erstellt werden.'
}